import axios from 'axios';
import isEmpty  from 'lodash/isEmpty';
import getAppConfigParm from '../config/AppConfig';
import { prtApiStart, prtApiEnd, prtVar, prtObjVar, prtMsg } from '../utils/prt';


export default class PicDeleteRequest {

    constructor(requestName) {
        this.apiRequestName = requestName;
        this.logtrace = false;
        this.uri = '';        /* this is api uri pattern */
        this.url = 
        this.userid = 'no userid';   /* used to identify user in error message */
        this.authToken = '';
        this.hostAndPort = getAppConfigParm("picUrl");  /* obtained from config file*/
        this.header = null;   /* gets set when setting token */
        this.error = '';
    }

    setUserId(uid) {
        this.userid = uid; 
        return this;
    }

    setUri(uri) {
        this.uri = uri;
        this.url = this.hostAndPort + uri;
        return this;
    }

    setAuthToken(token) {
        this.authToken = token;
        this.header = getAppConfigParm("axiosConfig", token);  
        return this;
    }

    setLogTrace(value) {
        this.logtrace = value; 
        return this;
    }

    // returns the original error that was returned by api
    getError() {
        return this.error;
    }

    exec() {
        let _self = this;
        let apiPromise  = new Promise (function resolver(resolve, reject) {    
            let errmsg = '';

            if (_self.logtrace) { 
                prtApiStart(_self.apiRequestName) 
                prtVar('uri', _self.uri);
                prtVar('userid', _self.userid);
                prtVar('authToken', _self.authToken);
                prtVar('url', _self.url );
                prtObjVar('header', _self.header );
            }

            axios.delete(_self.url, _self.header).then(function (response) {
                // _self.logtrace && prtMsg("This is response");
                // _self.logtrace && console.log(response);
                resolve(response);
            }).catch((error) => {
                _self.logtrace && prtMsg('I am now in axios catch block');
                // If error object is empty, I do not dispatch an app error event. 
                if (!isEmpty(error)) {
                    if (error.response) {   /* server responded with status code out of 2xx range(success) */
                        if (error.response.data.errmsg) {
                            errmsg = `UncaughtException ${error.response.status}: error encountered in ${_self.apiRequestName} for user ${_self.userid} ` +
                                            `${error.response.data.errmsg}`
                        }
                        _self.error = error.response;
                        if (_self.logtrace) {console.log(error.response)};
                    } else if (error.request) { /* request made but no response received */
                        errmsg = `UncaughtException(1): no response from uri:${_self.url}' from API ${_self.apiRequestName} by user ${_self.userid}`;
                        _self.error = error.request;
                        if (_self.logtrace) {console.log(error.request)};
                    } else { /* something happened setting up request that triggered error */
                        if (error.message.indexOf('Network Error') !== -1 ) {
                            errmsg =  `NetworkError: occurred making axios call uri:'${_self.url}' from API ${_self.apiRequestName} by user:'${_self.userid}' ErrorMsg: ${error.message}`;
                        } else {
                            errmsg = `UncaughtException(2): calling uri:'${_self.url}' from API ${_self.apiRequestName} from ${_self.userid}`
                        }
                        _self.error = error.message;
                        if (_self.logtrace) {console.log(error.message)};
                    }
                } else {
                    errmsg = `UncaughtException(3): occurred with axios call uri:'${_self.url}' from API:${_self.apiRequestName}. user:'${_self.userid}'. If error object  empty, this may be a coding error (not API) within axios then block`;
                } /* end of !isEmpty */
                reject(errmsg);
            });
            if (_self.logtrace) {prtApiEnd(_self.apiRequestName) }
        }); /* end Promise */
        return apiPromise;
    }
}


// WEBPACK FOOTER //
// ./src/apis/PicDeleteRequest.js